
import config from "../../config";
import axios from "axios";
import * as UAParser from "ua-parser-js";
import { getEnvironmentFromDomain } from "../../utils/helperFunctions";

function getBaseUrl(): string {
  const env = getEnvironmentFromDomain();
  
  switch (env) {
    case 'dev':
      return 'https://d.api.enncrypto.com';
    case 'qa':
      return 'https://q.api.enncrypto.com';
    case 'stage':
      return 'https://s.api.enncrypto.com';
    case 'prod':
      return 'https://api.enncrypto.com';
    default:
      return 'https://d.api.enncrypto.com';
  }
}

function getQrServiceBaseUrl(): string {
  const env = getEnvironmentFromDomain();
  
  switch (env) {
    case 'dev':
      return 'https://d-api.ops.enncrypto.com';
    case 'qa':
      return 'https://q-api.ops.enncrypto.com';
    case 'stage':
      return 'https://s.api.enncrypto.com';
    case 'prod':
      return 'https://api.enncrypto.com';
    default:
      return 'https://d-api.ops.enncrypto.com';
  }
}

// Replace your existing axios instances with these:
const api = axios.create({
  baseURL: getBaseUrl(),
});

const qrServiceApi = axios.create({
  baseURL: getQrServiceBaseUrl(),
});



export const fetchProductConfig = async (
  Id: string
): Promise<any> => {
  try {
    const encodedId = encodeURIComponent(Id);
    const env = getEnvironmentFromDomain()
    const url = `api/config/v1/ScanExp/${env}/${encodedId}`;
    const response = await api.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    const isSuccess = response.status === 200;
    if (!isSuccess) {
      throw new Error(
        `Failed to fetch product config with status: ${response.status}`
      );
    }

    return { configs: response.data.data };
  } catch (error) {
    console.error("Fetch product config error:", error);
    throw error;
  }
};


export const startSession = async (
  productId: string | null,
  geoLocation: any,
  metadata: any,
  productConfigId: any,
  mainCameraDeviceId?: string | null,
  
): Promise<any> => {
  try {
    const ua = new UAParser.UAParser();
    const url = "api/session/v1/session";
    const storedDeviceModel = localStorage.getItem('deviceModel')
    const deviceDetails = ua.getResult();
    const deviceModel = storedDeviceModel
      ? `${deviceDetails.device?.model} ${storedDeviceModel}`
      : deviceDetails.device?.model
     const enhancedDeviceDetails = {
      ...deviceDetails,
      device: {
        ...deviceDetails.device,
        model: deviceModel,
      },
    }
    console.log("enhancedDeviceDetails ----->", enhancedDeviceDetails);

    const payload = {
      data: {
        createdBy: "vyu-scan-app",
        updatedBy: "vyu-scan-app",
        productConfigId: productConfigId,
        sessionType: [
          {
            sessionRequest: "QR",
            serviceName: "QR",
            additionalData: {
              deviceId: mainCameraDeviceId,
              productSku: productId,
            },
          },
        ],
        deviceMeta: {
          ...metadata,
          device_details: enhancedDeviceDetails,
          geoLocation
        },
      },
    };
    const res = await api.post(
      url,
      payload,

      {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    const isSuccess = res.status === 200;
    if (isSuccess) return await res?.data?.data;

    throw new Error(`startSessionFailed | status: ${res.status}`);

    // const response = await fetch(url, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //     //'Authorization': `Bearer ${accessToken}`,
    //   },
    //   body: JSON.stringify({
    //     product_config_id: productConfigId,
    //     //access_token: accessToken,
    //     geo_location: geoLocation,
    //     metadata,
    //   }),
    // });

    // if (!response.ok) {
    //   throw new Error(
    //     `Failed to start session with status: ${response.status}`
    //   );
    // }

    // return await response.json();
  } catch (error) {
    console.error("Start session error:", error);
    throw error;
  }
};
export const fetchEntityConfig = async (
  shortId: string,
  lat?: number,
  long?: number,
  geoFencing: boolean = false,
  serialCode: boolean = false
): Promise<any> => {
  try {
    const url = "api/avengerhub/v1/entity-config";
    const requestData = {
      shortId,
      lat,
      lon : long,
      geoFencing,
      serialCode
    };

    const response = await api.post(
      url,
      requestData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const isSuccess = response.status === 200;
    if (isSuccess) {
      console.log("Entity config fetched successfully:", response.data);
      return response.data;
    }
    
    console.warn(`fetchEntityConfig failed with status: ${response.status}`);
    return null;
  } catch (error) {
    console.error("fetchEntityConfig error:", error);
    return null;
  }
};

export const updateQRScan = async (
  sessionId,
  shortId,
  data,
  generalCounter,
  limitCounter
): Promise<any> => {
  try {
    const url = `api/starlink/v1/qr/serial`;
    const response = await api.post(
      url,
      JSON.stringify({
        data: {
          ...data,
          sessionId,
          shortId,
          limitCounter,
          generalCounter,
        },
      }),
      {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    const isSuccess = response.status === 200;
    if (isSuccess) return await response.data;
    return null;
  } catch (error) {
    console.error("updateQRScan error:", error);
    return null;
  }
};


export const uploadImage = async (
  sessionId: string,
  shortId: string,
  imageBlob: Blob,
  lat?: any,
  long?: any,
  clientName?: string,
): Promise<any> => {
  try {
    let url = `api/session/v1/session-image-task?sessionId=${sessionId}&shortId=${shortId}`;
    if (lat && long) {
      url += `&lat=${lat}&long=${long}`;
    }
    if (clientName) {
      url += `&clientName=${clientName}`;
    }
    console.log(`Uploading image for session: ${sessionId}`);
    
    const res = await api.post(
      url,
      imageBlob,
      {
        headers: {
          'Content-Type': 'application/octet-stream',
        },
        transformRequest: [(data) => data],
      }
    );
    
    const isSuccess = res.status === 200;
    if (isSuccess) {
      console.log('Image uploaded successfully:', res.data);
      return res.data;
    }

    throw new Error(`uploadSessionImage failed | status: ${res.status}`);
    
  } catch (error) {
    console.error("Upload session image error:", error);
    throw error;
  }
};

export const sendSessionResult = async (
  result: string,
  analysisResult: number,
  uiResult: string,
  genuineThreshold: number,
  fakeThreshold: number,
  sessionId: string,
  captureType?: string
): Promise<any> => {
  try {
    const sessionData = {
      sessionId,
      source: 'stream',
      result,
      sessionCompletedAt: new Date().toISOString(),
      analysisResult,
      imageCountConfig: JSON.stringify({
        genuine_threshold: genuineThreshold,
        fake_threshold: fakeThreshold,
      }),
      uiResult,
      captureType : captureType || 'stream',
    };

    console.log('[API] Sending session result:', sessionData);
    
    const response = await api.post('/session-result', sessionData, {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    });

    if (response.status !== 200) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    
    console.log('[API] Session result sent successfully');
    return response.data;
  } catch (error) {
    console.error('[API] Error sending session result:', error);
    throw error;
  }
};


// Mock API Services for development
// Replace with actual implementations when APIs are ready

// export const fetchProductConfig = async (productId: string): Promise<any> => {
//   console.log("Mock API: fetchProductConfig called with:", productId);

//   // Return mock configuration
//   return {
//     configs: {
//       overlay_file_url: "https://example.com/overlay.png",
//       experience_config: {
//         image_count: 1,
//         qrUrl: "https://en5.in/DENINJ8X3",
//         shortId: "ABC123",
//         viewFinderConfig: {
//           preScanText: "Please scan the QR code",
//           focusText: "Focus on QR code and click capture",
//           invalidQRText: "Invalid QR code",
//           verifyingText: "Verifying product...",
//         },
//         ui_result_config: {
//           GENUINE: {
//             icon: "https://vyu-web-sdk.enncrypto.com/v1_sdk_assets/Icons/genuine.png",
//             text: "This product is genuine",
//             status: "Genuine",
//             scanAgainButton: "Scan Again",
//             button1: "Know More",
//             background: "#fff",
//             statusColour: "green",
//             textBgColour: "grey",
//             bgColour: "white",
//           },
//         },
//         brand_engagement: {
//           type: "CUSTOM_REDIRECT",
//           is_custom: true,
//           theme: {
//             messages: {
//               "Decide.HomeButton": "HOME",
//               "Decide.BrandEngagement": "BRAND ENGAGEMENT",
//               "Decide.ScanAgainButton": "SCAN AGAIN",
//             },
//           },
//           customSplashScreenConfig: {
//             backgroundImage:
//               "https://vyu-web-sdk.enncrypto.com/v1_sdk_assets/Images/GulfOilBGSplashScreen.jpg",
//             logo: "https://vyu-web-sdk.enncrypto.com/v1_sdk_assets/Images/GulfOilLogoSplashScreen.png",
//             showStartButton: "true",
//             text: "VERIFICATION APP",
//           },
//           placeholder_question_mark_content:
//             "https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/vyu_brand_engagement/Gulf+Oil/GulfOil-ExplainerVideo.mp4",
//           start_loading_animation:
//             "https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/vyu_brand_engagement/Gulf+Oil/Gulf_logo_small.png",
//           button: {
//             brandEngagementBtn: {
//               redirectUrl:
//                 "https://india.gulfoilltd.com/products/commercial-vehicle/other-fluids/adblue",
//             },
//           },
//         },
//       },
//     },
//   };
// };
